/** Session flag so MetaOAuthCallback (full-page redirect) can pass permission errors to the shell. */
const PENDING_KEY = 'ch3_meta_permission_error_v1';

export const META_PERMISSIONS_REQUIRED_CODE = 'META_PERMISSIONS_REQUIRED';

export function stashPendingMetaPermissionError(payload) {
  try {
    sessionStorage.setItem(PENDING_KEY, JSON.stringify(payload));
  } catch {
    /* ignore quota / private mode */
  }
}

export function consumePendingMetaPermissionError() {
  try {
    const raw = sessionStorage.getItem(PENDING_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(PENDING_KEY);
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearPendingMetaPermissionErrorStorage() {
  try {
    sessionStorage.removeItem(PENDING_KEY);
  } catch {
    /* ignore */
  }
}

export function isMetaAccountsPermissionRequiredError(error) {
  return (
    error?.response?.status === 403 &&
    error?.response?.data?.error_code === META_PERMISSIONS_REQUIRED_CODE
  );
}

export function metaPermissionErrorFromAccountsApi(error) {
  const body = error?.response?.data || {};
  if (body.detail) {
    console.warn('[Meta permissions]', body.detail);
  }
  return {
    message: body.error || 'Faltan permisos para usar Meta Ads',
    missingPermissions: Array.isArray(body.missing_permissions) ? body.missing_permissions : [],
    detail: body.detail,
    source: 'accounts_api',
  };
}

/** Human-readable Spanish labels for common Meta OAuth scope names (fallback only). */
export function describeMetaScopeEs(scope) {
  const s = String(scope || '').trim();
  const map = {
    ads_management: 'Administración de anuncios',
    ads_read: 'Lectura de anuncios',
    business_management: 'Administración del negocio',
    pages_show_list: 'Lista de páginas',
    pages_read_engagement: 'Lectura de interacciones de páginas',
    instagram_basic: 'Instagram básico',
    instagram_manage_insights: 'Estadísticas de Instagram',
    catalog_management: 'Catálogos',
    whatsapp_business_management: 'WhatsApp Business',
    public_profile: 'Perfil público',
    email: 'Correo electrónico',
  };
  return map[s] || s.replace(/_/g, ' ');
}
